import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { serviceDetails } from '../../../content/site'

// Services hero, on the new design (Task 8). Same dark .hero-section treatment as the About
// hero (reuses .about-hero-inner's single-column grid override verbatim) so the two pages
// read as siblings, per the task brief. The old hero's five-item "claim your first free
// unit" checklist has no counterpart in the ported design - kept here as a small checklist
// under the lead paragraph (new CSS under the SERVICE PAGES banner in site.css) rather than
// dropped, per the content rule that nothing existing is silently removed.
const Hero = () => {
  const { hero } = serviceDetails
  return (
    <section className="hero-section service-hero">
      <div className="hero about-hero-inner service-hero">
        <div className="hero-eyebrow">{hero.eyebrow}</div>
        <h1>{hero.title}</h1>
        <p className="hero-desc about-hero-desc">{hero.paragraph}</p>
        <div className="services-hero-claims">
          <h2 className="services-hero-claims-title">{hero.claimsTitle}</h2>
          <ul className="services-hero-claims-list">
            {hero.claims.map((claim, i) => (
              <li key={i}>
                <FontAwesomeIcon icon={faCircleCheck} />
                <span>{claim}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Hero
